<style lang='scss' scoped>
.myCloud{
  position: relative;
  padding-bottom: 100px;;
  .sort{
    position:fixed;
    top:1.64rem;
    opacity: 0;
    width:calc(100% - 0.64rem);
    background: #fff;
    z-index: 998;
    font-size:0.28rem;
    height:0.74rem;
    background-color: #f7f7f7;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    padding: 0rem 0.32rem;
    
    
    .sort_boxL{
      height:0.74rem;
      line-height: 0.74rem;
      padding-top:0.02rem;
      img{
        margin-top:-0.03rem;
        width:0.22rem;
        vertical-align: middle;
      }
      div{
        color:#333;
        margin-left:0.1rem;
      }
    }
    .sort_boxR{
      padding-top:0.02rem;
      height:0.74rem;
      line-height: 0.74rem;
      img{
        
        margin-top:-0.04rem;
        width:0.28rem;
        vertical-align: middle;
      }
      div{
        color:#666;
        margin-left:0.1rem;
      }
    }
  }
  .codeData{
    margin-top:2.37rem;
    padding-bottom: 2rem;
    li{
      margin-top:0.3rem ;
      margin-left: 3.46%;
      width: 44.26%;
      height:4.18rem;
      border:1px solid #e6e9ed;
      position: relative;
      .selectImg{
        position: absolute;
        top:0.2rem;
        left:0.2rem;
        img{
          width:0.36rem;
        }
      }
      .img_box{
        // width:2.92rem;
        height:2.48rem;
        line-height: 2.48rem;
        border-top-right-radius: 0.05rem;
        border-top-left-radius: 0.05rem;
        padding:0.2rem;
        text-align: center;
        background-color: #e6e9ed;
        img{
          vertical-align: middle;
          border-radius: 0.1rem;
          max-width: 87.95%;
          max-height: 2.48rem;
        }
      }
      .codeInfo{
        padding: 0.2rem 0.32rem 0.24rem 0.32rem;
        p{
          font-size:0.28rem;
          // line-height: 0.3rem;
          margin-bottom: 0.2rem;
        }
        div.m_clearLR{
          font-size:0.24rem;
          line-height: 0.24rem;
          color:#9a9a9a;
        }
      }
    }
  }
  .selectSort{
    position: fixed;
    top:2.37rem;
    z-index: 1002
  }
  .codeList{
    margin:2.37rem 0 0 0.32rem;
    li{
      padding-top:0.15rem;
      display: flex;
      & .listDiv{
        text-align: center;
        width:1.16rem;
        height:1.16rem;
        background-color: #e6e9ed;
        line-height: 1.1rem
      }
      & .listDiv > img{
        vertical-align: middle;
        max-width: 90%;
        max-height: 90%;
      }
      .info{
        border-bottom: 1px solid #e6e6e6;
        margin-top:0.25rem;
        margin-left:0.25rem;
        height:1.05rem;
        flex: 1;
        img{
          margin-top:0.15rem;
          margin-right: 0.32rem;
          width:0.36rem;
        }
        p{
          font-size:0.28rem;
          color:#333;
          line-height: 0.28rem;
          margin-bottom:0.15rem;
        }
        span{
          color:#9a9a9a;
          font-size:0.24rem;
          margin-right:0.35rem;
        }
      }
    }
  }
  .editBottom{
    position:fixed;
    bottom: 0px;
    width:100%;
    border-top:1px solid #ebebeb;
    z-index: 999;
    
  }
  .noData{
    text-align: center;
    margin-top:0.5rem;
    color:#666;
    font-size:0.28rem;
    padding-bottom: 1.5rem;
  }
  .noDataEmpty{
    width:100%;
    top:1.47rem;
    text-align: center;
    position: absolute;
    img{
      width:1.99rem;
    }
    .text{
      font-size:0.28rem;
      color:#666666;
      margin-top:0.6rem;
    }
    .feedback{
      margin-top:0.6rem;
      width:2.25rem;
      height:0.72rem;
      line-height: 0.72rem;
      font-size:0.3rem;
      text-align: center;
      color:#0497ff;
      border:1px solid #0497ff;
      border-radius: 0.05rem;
    }
  }
  .noLogin{
      width:100%;
      top:1.07rem;
      position: absolute;
      text-align: center;
      img{
        width:3.5rem;
      }
      .text{
        font-size:0.28rem;
        color:#666666;
        margin-top:0.3rem;
        padding: 0px 0.3rem;
      }
      .feedback{
        margin-top:0.6rem;
        width:2.25rem;
        height:0.72rem;
        line-height: 0.72rem;
        font-size:0.3rem;
        text-align: center;
        color:#0497ff;
        border:1px solid #0497ff;
        border-radius: 0.05rem;
      }
    }
    .refreshText {
      position: absolute;
      width: 100%;
      text-align: center;
      line-height: 50px;
      text-align: center;
      left: 0;
      top: 10px;
    }
    #refreshContainer{
      background-color: #fff;
    }
    .hiddenBox{
      position: fixed;
      top:0px;
      right: 0px;
      left:0px;
      bottom:0px;
      z-index: 1001;
      background-color: transparent;
    }
}
.selectList{
  
  -webkit-tap-highlight-color:transparent;
}
</style>
<template>
  <div class="myCloud">
    <div class="whiteBox" v-show="showWhite" ></div>
    <div class="hiddenBox" v-show="showSort" @touchstart="touchHidden" @click="closeHidden"></div>
    <div class='sort m_clearLR' >
      <div class="sort_boxL m_clearLR m_floatL" @click="openSort">
        <img src="@/../public/images/small.png"  alt="" :class="sort==2||sort==4||sort==6?'rotate180':''">
        <div class="m_floatR">{{sortName}}</div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR" v-if='changeList' @click="changeStyle">
        <img src="@/../public/images/list.png" alt="" class="">
        <div class="m_floatR zhen_1">{{_lang[$route.query.type].zhen_1}}<span id="tests"></span></div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR" v-else @click="changeStyle">
        <img src="@/../public/images/list_2.png" alt="" class="">
        <div class="m_floatR zhen_2">{{_lang[$route.query.type].zhen_2}}</div>
      </div>
    </div>
    <selectSort class="selectSort" v-show="showSort" @selectSort='selectSort'></selectSort>
    <div class="refreshText">
      <p v-show="!loadingShow">{{loadingText}}</p>
      <img src="@/assets/loading.gif" v-show="loadingShow">
    </div>
    <ul class="codeData m_clearLR " id="refreshContainer" v-if="changeList">
      <li class="m_floatL " v-for="(item,index) in cloudData" :key="index" @click="selectTag(item,$event)">
        <div class="selectImg" v-show="isEdit"  @click="selectList(item)">
            <img v-if="!item.select" class="editImg" src="@/../public/images/select.png" alt="">
            <img v-else class="editImg" src="@/../public/images/selected.png" alt="">
        </div>
        <div class="img_box">
          <img :src="item.img" alt="">
        </div>
        <div class="codeInfo">
          <p class="textLine">{{item.name}}</p>
          <div class="m_clearLR">
            <div class="date m_floatL">{{item.addTime|partFilter('')}}</div>
            <div class="size m_floatR">{{item.width+'x'+item.height}}</div>
          </div>
        </div>
      </li>
    </ul>
    <ul class="codeList" v-else  id="refreshContainer">
      <li class="m_clearLR" v-for="(item,index) in cloudData" :key="index" @click="selectTag(item,$event)">
        <div class="listDiv m_floatL">
          <img :src="item.img" />
        </div>
        <div class="m_floatL info">
          <div class="m_floatL">
            <p style="max-width:5rem;" class="textLine">{{item.name}}</p>
            <span>{{item.addTime|partFilter('')}}</span>
            <span>{{item.width+'x'+item.height}}</span>
          </div>
          <div class="m_floatR selectList" v-show="isEdit"  @click="selectList(item)">
            <img v-if="!item.select" class="editImg" src="@/../public/images/select.png">
            <img v-else  class="editImg" src="@/../public/images/selected.png" >
          </div>
        </div>
      </li>
    </ul>
    <div v-show="noDataCloud" class="noDataEmpty">
        <img src="@/../public/images/noData.png" />
        <div class="text ">{{_lang[$route.query.type].zhen_5}}</div>
      </div>
    <div v-show="noLogin" class="noLogin">
      <img src="@/../public/images/noLogin.png" />
      <div class="text zhen_3">{{_lang[$route.query.type].zhen_3}}</div>
      <div class="feedback m_tran50 zhen_4" @click="toLogin">{{_lang[$route.query.type].zhen_4}}</div>
    </div>
    <div class="noData zhen_5" v-show="noMoreData">
      {{_lang[$route.query.type].zhen_5}}</div>
    <editBottom :isRename="isRenameShow"  v-show="isEdit&&cloudData.length>0" class="editBottom" @selectDelete='selectDelete' @selectAll='selectAll' @selectRename='selectRename'></editBottom>
    <messageBox @confirm='confromDelete' @cancel='cancelDelete' v-show="isDelete"></messageBox>
    <rename @confirm='confromRename' :name="nameRe" @cancel='cancelRename' v-show="isRename"></rename>
  </div>
</template>

<script>
import selectSort from '@/components/selectSort'
import {lang} from '@/utils/i18n'
import editBottom from '@/components/editBottom'
import rename from '@/components/rename'
import messageBox from '@/components/messageBox'
import JSEncrypt from "jsencrypt"
import jsSha256 from "js-sha256"
import CryptoJS from "crypto-js"
import {cloundList,deleteClound,updateClound} from '@/api/api'
import { clearTimeout } from 'timers';
import {GetQueryString} from '@/../public/js/main.js'
var bridge = {
  default: this,
  call: function(b, a, c) {
    var e = "";
    "function" == typeof a && ((c = a), (a = {}));
    a = { data: void 0 === a ? null : a };
    if ("function" == typeof c) {
      var g = "dscb" + window.dscb++;
      window[g] = c;
      a._dscbstub = g;
    }
    a = JSON.stringify(a);
    if (window._dsbridge) e = _dsbridge.call(b, a);
    else if (window._dswk || -1 != navigator.userAgent.indexOf("_dsbridge"))
      e = prompt("_dsbridge=" + b, a);
    return JSON.parse(e || "{}").data;
  },
  register: function(b, a, c) {
    c = c ? window._dsaf : window._dsf;
    window._dsInit ||
      ((window._dsInit = !0),
      setTimeout(function() {
        bridge.call("_dsb.dsinit");
      }, 0));
    "object" == typeof a ? (c._obs[b] = a) : (c[b] = a);
  },
  registerAsyn: function(b, a) {
    this.register(b, a, !0);
  },
  hasNativeMethod: function(b, a) {
    return this.call("_dsb.hasNativeMethod", { name: b, type: a || "all" });
  },
  disableJavascriptDialogBlock: function(b) {
    this.call("_dsb.disableJavascriptDialogBlock", { disable: !1 !== b });
  }
};
!(function() {
  if (!window._dsf) {
    var b = {
        _dsf: { _obs: {} },
        _dsaf: { _obs: {} },
        dscb: 0,
        dsBridge: bridge,
        close: function() {
          bridge.call("_dsb.closePage");
        },
        _handleMessageFromNative: function(a) {
          var e = JSON.parse(a.data),
            b = { id: a.callbackId, complete: !0 },
            c = this._dsf[a.method],
            d = this._dsaf[a.method],
            h = function(a, c) {
              b.data = a.apply(c, e);
              bridge.call("_dsb.returnValue", b);
            },
            k = function(a, c) {
              e.push(function(a, c) {
                b.data = a;
                b.complete = !1 !== c;
                bridge.call("_dsb.returnValue", b);
              });
              a.apply(c, e);
            };
          if (c) h(c, this._dsf);
          else if (d) k(d, this._dsaf);
          else if (((c = a.method.split(".")), !(2 > c.length))) {
            a = c.pop();
            var c = c.join("."),
              d = this._dsf._obs,
              d = d[c] || {},
              f = d[a];
            f && "function" == typeof f
              ? h(f, d)
              : ((d = this._dsaf._obs),
                (d = d[c] || {}),
                (f = d[a]) && "function" == typeof f && k(f, d));
          }
        }
      },
      a;
    for (a in b) window[a] = b[a];
    bridge.register("_hasJavascriptMethod", function(a, b) {
      b = a.split(".");
      if (2 > b.length) return !(!_dsf[b] && !_dsaf[b]);
      a = b.pop();
      b = b.join(".");
      return (b = _dsf._obs[b] || _dsaf._obs[b]) && !!b[a];
    });
  }
})();
export default {
  data(){
    return{
      currentIndex:0,
      showSort:false,
      page_size:10,
      mac:"daf3b950-27ee-4d",
      page:1,
      cloudData:[],
      isDelete:false,
      sort:'2',
      isMy:false,
      noMoreData:false,
      changeList:true,
      loadingData: false,
      isReflesh:false,
      showBottom:false,
      isRenameShow:false,
      noLogin:false,
      hiddenShow:false,
      loadingShow: false,
      loadingText:'',
      isEdit:false,
      showWhite:true,
      isRename:false,
      noDataCloud:false,
      tagTime:false,
      nameRe:'',
      isAll:false,
      clickSory:false,
      sortName: '',
      _lang:[],
      isMacCode:false,
    }
  },
  components:{
    selectSort,editBottom,messageBox,rename
  },
  created(){
    this._lang = lang
    this.sortName = this._lang[this.$route.query.type].zhen_18
    setTimeout(() => {
    
    document.querySelector('.myCloud .sort').style.opacity = '1'  
    if(this.$route.query.isEdit){
        this.isEdit = this.$route.query.isEdit
        this.showWhite = false
        setTimeout(() => {
          document.querySelector('.selectSort').style.top = '0.74rem'
          document.querySelector('.sort').style.top = '0px'
          var headTop = parseInt(window.getComputedStyle(document.querySelector('.codeData')).marginTop)
          document.querySelector('.codeData').style.marginTop = document.querySelector('.sort').clientHeight+'px'
          document.querySelector('.myhead').style.display = 'none'  
          var bottomHeight = 49
          if(this.isIphonex()){
            document.querySelector('.editBottom').style.top = (window.screen.height-bottomHeight-headTop)+'px'
          }
        // document.querySelector('.editBottom').style.top = (window.screen.height-60-120.5)+'px'
        // document.querySelector('.editBottom').style.top = (window.screen.height*0.02-1.2-2.41)+'rem'  
        // alert(document.querySelector('.editBottom').style.top)
      }, 0);
    }else{
      document.querySelector('.myhead').style.display = 'block'  
    }
    }, 0);
    setTimeout(() => {
      var _element = document.getElementById("refreshContainer"),
        _refreshText = document.querySelector(".refreshText"),
        _startPos = 0,
        _transitionHeight = 0;
      _element.addEventListener(
        "touchstart",
        e => {
          console.log("初始位置：", e.touches[0].pageY);
          _startPos = e.touches[0].pageY;
          _element.style.position = "relative";
          _element.style.transition = "transform 0s";
          this.loadingText = "";
          this.loadingShow = false;
        },
        false
      );

      _element.addEventListener(
        "touchmove",
        e => {
          console.log("当前位置：", e.touches[0].pageY);
          _transitionHeight = e.touches[0].pageY - _startPos;
          if (_transitionHeight > 0 && _transitionHeight < 60) {
            // _refreshText.innerText = '下拉刷新';
            // this.loadingText = "下拉刷新";
            _element.style.transform =
              "translateY(" + _transitionHeight + "px)";
            if (_transitionHeight > 45) {
              
              this.isReflesh = true
              this.loadingText = "释放更新";
            }
          }
        },
        false
      );
      _element.addEventListener(
        "touchend",
        e => {
          _element.style.transition = "transform 0.5s ease 1s";
          _element.style.transform = "translateY(0px)";
          this.loadingShow = true;
           
          setTimeout(() => {
           if(this.isReflesh){
              this.getData()
            }
            this.loadingShow = false;
          }, 1000);
          //  this.getData();
          // todo...
        },
        false
      );
    }, 10);
    // this.getData()
    window.onscroll = null
    var k = 0 , n = 0
    // alert(window.screen.height)
    // window.onscroll = () => {
    //   // document.querySelector('.editBottom').style.top = (window.screen.height-20-49-parseInt(window.getComputedStyle(document.querySelector('.codeData')).marginTop))+'px'
    //   if (
    //     this.getScrollTop() + this.getWindowHeight() >=
    //     this.getScrollHeight() - 100
    //   ) {
    //   	console.log(document.querySelector('.editBottom').offsetTop)
    //   	// if(document.querySelector('.editBottom').offsetTop!=k)
    //   	//	document.querySelector('.editBottom').style.top=document.querySelector('.editBottom').offsetTop+'px'
    //     document.querySelector('#tests').innerHTML = window.getComputedStyle(document.querySelector('.codeData')).marginTop
    //     // document.querySelector('.editBottom').style.position = 'fixed'
    //   }else{
    //   	k = document.querySelector('.editBottom').offsetTop
    //   }
    // }
    window.onscroll = () => {
      if (
        this.getScrollTop() + this.getWindowHeight() >=
        this.getScrollHeight() - 500
      ) {
        this.addGetData();
      }
    };
  },
  watch:{
    '$route':function(val){
      // console.log(val.query.type)
      if(this.sort==3||this.sort==4){
        this.sortName = lang[this.$route.query.type].zhen_18
      }else if(this.sort==1||this.sort==2){
        this.sortName = lang[this.$route.query.type].zhen_20
      }else{
        this.sortName = lang[this.$route.query.type].zhen_19
      }
        this.isMy = false
        this.isMacCode = false
      // else{
      //   this.isMacCode = false
      // }
      this.noMoreData = false
      this.noDataCloud = false
      this.getData()
    }
  }
  ,
  filters: {
    //转化时间年月日
    // partFilter: function(value, type) {
    //   if (!value) return "";
    //   var time = value.split("T")[0];
    //   var year = time.split("-");
    //   value = year[0] + "-" + year[1] + "-" + year[2].split(' ')[0] ;
    //   return value;
    // }
    partFilter: function(value, type) {
      if (!value) return "";
      var date = new Date(value);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d ;
    }
  },
  methods:{
    touchHidden(){
      this.showSort  = false
    },
    base64_encode(str) {
    var c1, c2, c3;
    var base64EncodeChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var i = 0,
      len = str.length,
      string = "";

    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff;
      if (i == len) {
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt((c1 & 0x3) << 4);
        string += "==";
        break;
      }
      c2 = str.charCodeAt(i++);
      if (i == len) {
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt(
          ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
        );
        string += base64EncodeChars.charAt((c2 & 0xf) << 2);
        string += "=";
        break;
      }
      c3 = str.charCodeAt(i++);
      string += base64EncodeChars.charAt(c1 >> 2);
      string += base64EncodeChars.charAt(
        ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
      );
      string += base64EncodeChars.charAt(
        ((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6)
      );
      string += base64EncodeChars.charAt(c3 & 0x3f);
    }
    return string;
  },
  getEncry(str){
    let k2 = this.getCode(this.mac); // 对需要加密的数据进行加密
    k2 = this.buf2hex(this.base64ToUint8Array(k2));
    console.log("k2:" + k2);
    console.log("qqqqqqqqqqqqqqqqqq");
    var k3 = this.encrypt(JSON.stringify(str));
    // k3 = this.base64_encode(k3)
    k3 = this.base64ToUint8Array(k3);
    k3 = this.buf2hex(k3);
    var k4 = this.base64_encode("key=" + k2 + "&text=" + k3);
    var k5 = this.stringArrayBuffer(k4);
    var k6 = this.buf2hex(k5);

    let sha256 = jsSha256.sha256; //这里用的是require方法
    var k7 = sha256(k6);
    return k6+','+k7
  },
    getCode(str) {
    //此处操作与后端约定参数
    // 创建RSAKey对象
    let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXRtG/gee0XLO+AGkp3qdI3pkntdB/5ej3DiCD3ZfTv1F1zl37I5ncXIQ9zpK5WEiGTCoVrywclj9etBdecchO2ZMVRT5MBb0EL7FZTdJz93xoAW6ZKbAUS4GBo20aM/7l+3JdX7L/fu/MIvT0GkKoNyTmWCC9VJ8/nKnj4b1uVwIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
    let encryptStr = new JSEncrypt();
    encryptStr.setPublicKey(pubKey); // 设置 加密公钥
    let data = encryptStr.encrypt(str.toString()); // 进行加密
    return data;
  },
  buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map
      .call(new Uint8Array(buffer), x => ("00" + x.toString(16)).slice(-2))
      .join("");
  },
  stringArrayBuffer(str) {
    const buffer = new ArrayBuffer(str.length);
    const bytes = new Uint8Array(buffer);

    str.split("").forEach(function(str, i) {
      bytes[i] = str.charCodeAt(0);
    });

    return buffer;
  },
  encrypt(plaintText) {
    const CRYPTOJSKEY = "daf3b950-27ee-4d";
    var plaintText = plaintText;
    var options = {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    };
    var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
    var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
    var encryptedBase64Str = encryptedData.toString().replace(/\//g, "_");
    encryptedBase64Str = encryptedBase64Str.replace(/\+/g, "-");
    return encryptedBase64Str;
  },
   base64ToUint8Array(base64String) {
　　　　const padding = '='.repeat((4 - base64String.length % 4) % 4);
       const base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/');

       const rawData = window.atob(base64);
       const outputArray = new Uint8Array(rawData.length);

       for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
       }
       return outputArray;
},
  _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  },
    closeHidden(){
      this.showSort = false
      this.hiddenShow = false
    },
    showHidden(){
      if(this.showSort)
        this.showSort = false
    },
    isIphonex  () {
      if (typeof window !== 'undefined' && window) {
        return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
      }
        return false;
    },
    getIsIphonex () {
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isIOS) {
            if (screen.height == 812 && screen.width == 375) {
                return true;
            }
            else {
                return false;
            }
        }
    },getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight
    },
    //获取文档完整的高度
     getScrollHeight() {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
     getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    toLogin(){
      dsBridge.call("Dlabel.toLogin", '');
    },
    selectTag(item,e){
      //var width = 0,height =0
      // if(item.fileSize){
      //   if(item.fileSize.toLowerCase().indexOf('x')!=-1){
      //     width = item.fileSize.split('x')[0]
      //     height = item.fileSize.split('x')[1]
      //   }else{
      //     width = item.fileSize.split('*')[0]
      //     height = item.fileSize.split('*')[1]
      //   }
      // }
      if(!this.$route.query.isEdit){
        clearTimeout(_tagTime)
        if(this.tagTime)
          return
        var _tagTime = setTimeout(() => {
          this.tagTime  = false
        }, 2000)
        this.tagTime = true
        console.log(JSON.stringify({
          id: item.id,
          name: item.name,
          file: item.file,
          width:item.width,
          height:item.height
        }))
        dsBridge.call("Dlabel.getUserTemplate", {
          id: item.id,
          name: item.name,
          file: item.file,
          width:item.width,
          height:item.height
        });
      }else{
        if(e.target.className.indexOf('editImg')==-1)
          this.selectList(item)
      }
    },
    cancelDelete(){
      this.isDelete = false
    },
    cancelRename(){
      this.isRename = false
    },
    selectDelete(){
      var temp = []
      this.cloudData.forEach(item=>{
        if(item.select){
          temp.push(item)
        }
      })
      if(temp.length<=0){
        this.$toast(lang[this.$route.query.type].zhen_33)
        return
      }
      this.isDelete = true
    },
    selectRename(){
      this.clickSory = false
      var temp = []
      this.cloudData.forEach(item=>{
        if(item.select){
          temp.push(item)
        }
      })
      if(temp.length!=1){
        this.$toast(lang[this.$route.query.type].zhen_25)
        return
      }
      this.nameRe = temp[0].name
      this.isRename = true
    },
    selectAll(){
      if(!this.isAll){
        this.cloudData.forEach(item=>{
          item.select = true
        })
        this.isAll = true
      }else{
        this.cloudData.forEach(item=>{
          item.select = false
        })
        this.isAll = false
      }
    },
    confromRename(name){
      this.cloudData.forEach(item=>{
        if(item.select){
          var formData = new FormData()
          
          console.log(formData)
          console.log(this.cloudData)
          var temp = []
          this.cloudData.forEach(item=>{
            if(item.select){
              temp.push(item)
            }
          })
          var tempData = {name:name,id:temp[0].id,
          "equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          "equip": GetQueryString('equip'),
          src:2,
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
          }
          console.log(tempData)
          console.log('tempData')
          tempData = this.getEncry(tempData)
          // {mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]}
          updateClound(item.id,{mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]}).then(res=>{
            if(res.data.code==401||res.data.code==5002){
              dsBridge.call("Dlabel.deviceAlreadyLoggedIn",'');
              // return
            }else{
              this.$toast(lang[this.$route.query.type].zhen_24)
              dsBridge.call("Dlabel.cloudFileChanged",'');
            }
            this.isRename = false
            this.isRenameShow = false
            this.getData()
          })
        }
      })
    },
    confromDelete(){
      var temp = []
      this.cloudData.forEach(item=>{
        if(item.select){
          temp.push(item)
        }
      })
      var tempData = []
      temp.forEach((item,index)=>{
        ((i)=>{
          tempData.push(item.id)
          // deleteClound(item.id).then(res=>{
          //   if(i==temp.length-1){
          //     this.$toast(lang[this.$route.query.type].zhen_23)
          //     this.isDelete = false
          //     this.getData()
          //   }
          // })
        })(index)
      })
      tempData = {ids:tempData.join(','),"equipMeid": GetQueryString('equipMeid'),
        "equipVersion": GetQueryString('equipVersion'),
        "model": GetQueryString('model'),
        "equip": GetQueryString('equip'),
        src:2,
        "reqTime": new Date().getTime(),
        "version": GetQueryString('version'),
          "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
      }
      tempData = this.getEncry(tempData)
      deleteClound({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]}).then(res=>{
        if(res.data.code==401||res.data.code==5002){
          dsBridge.call("Dlabel.deviceAlreadyLoggedIn",'');
          // return
        }else{
          this.$toast(lang[this.$route.query.type].zhen_23)
          
          dsBridge.call("Dlabel.cloudFileChanged",'');
        }
        this.isDelete = false
        this.getData()
      })
    },
    selectList(item){
      console.log(item)
      item.select = !item.select
      var temp = []
      this.cloudData.forEach(item=>{
        if(item.select){
          temp.push(item)
        }
      })
      console.log(this.isRenameShow)
      if(temp.length==1){
        this.isRenameShow = true
        console.log(this.isRenameShow)
      }else{
        this.isRenameShow = false
      }
      // var temp = []
      // this.cloudData.forEach(item=>{
      //   if(item.select){
      //     temp.push(item)
      //   }
      // })
      // if(temp.length>0){
      //   this.showBottom = true
      // }else{
      //   this.showBottom = false
      // }
    },
    changeStyle(){
      this.changeList = !this.changeList
    },
    getData(){
      this.loadingData = true;
      // this.$indicator.open({
      //   text: 'Loading...',
      // });
      this.page = 1
      this.isReflesh = false
      var tempData = {
          pageSize:this.page_size,pageNo:this.page,type:this.sort,"equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          src:2,
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          // "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
          }
          if(!this.isMacCode)
            tempData.macCode = GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
          else{
            return
          }
        console.log(tempData)
          console.log('tempData')
      tempData = this.getEncry(tempData)
      
      if(!GetQueryString('token')||GetQueryString('token').length<10){
        this.noLogin = true
        this.cloudData = []
        this.noDataCloud = false
        return
      }
      cloundList({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]}).then(res=>{
        if(res.data.code==5002){
          this.isMacCode = true
          var tempQuery = this.$route.query
          delete tempQuery.macCode
          tempQuery.token = ''
          this.$router.push({name:'myCloud',query:tempQuery})
          this.isMy = true
          dsBridge.call("Dlabel.deviceAlreadyLoggedIn",'');
          // return
        }
        if(res.data.code==401||res.data.code==5002){
          this.noLogin = true
          this.cloudData = []
          this.noDataCloud = false
          // this.$indicator.close()
          return
        }
        this.page = 2
        this.noLogin = false
        var temp = res.data.data.list
        if(temp.length<=0){
          this.noDataCloud = true
        }
        else if(temp.length >this.page_size){
          this.noMoreData = true
        }
        temp.forEach(item=>{
          item.select = false
        })
        this.cloudData = temp
        this.loadingData = false
        // this.$indicator.close()
      }).catch(error=>{
        this.loadingData = false
        // this.$indicator.close()
      })
    },

    addGetData(){
      // this.$indicator.open({
      //   text: 'Loading...',
      // });
      if (this.loadingData) {
        return;
      }
      this.loadingData = true;
      this.isReflesh = false
      var tempData = {
          pageSize:this.page_size,pageNo:this.page,type:this.sort,"equipMeid": GetQueryString('equipMeid'),
          "equipVersion": GetQueryString('equipVersion'),
          "model": GetQueryString('model'),
          src:2,
          "equip": GetQueryString('equip'),
          "reqTime": new Date().getTime(),
          "version": GetQueryString('version'),
          // "macCode": GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
          }
          if(!this.isMacCode)
            tempData.macCode = GetQueryString('macCode')=='(null)'||GetQueryString('macCode')==''?'':GetQueryString('macCode')
          else{
            return
          }
        console.log(tempData)
          console.log('tempData')
      tempData = this.getEncry(tempData)
      cloundList({mcontext:tempData.split(',')[0],sign:tempData.split(',')[1]}).then(res=>{
        if(res.data.code==5002){
          this.isMacCode = true
          var tempQuery = this.$route.query
          delete tempQuery.macCode
          tempQuery.token = ''
          this.$router.push({name:'myCloud',query:tempQuery})
          this.isMy = true
          dsBridge.call("Dlabel.deviceAlreadyLoggedIn",'');
          // return
        }
        if(res.data.code==401||res.data.code==5002){
          this.noLogin = true
          this.cloudData = []
          this.noDataCloud = false
          // this.$indicator.close()
          return
        }
        this.page++
        this.noLogin = false
        var temp = res.data.data.list
        // if(temp.length<=0){
        //   this.noDataCloud = true
        // }
        // else if(temp.length >this.page_size){
        //   this.noMoreData = true
        // }
        temp.forEach(item=>{
          item.select = false
        })
        temp.forEach(element => {
          this.cloudData.push(element);
        });
        this.loadingData = false;
        // this.$indicator.close()
      }).catch(error=>{
        this.loadingData = false;
        // this.$indicator.close()
      })
    },
    openSort(){
      this.showSort = !this.showSort
    },
    selectSort(text){
      console.log(text)
      window.scrollTo(0,0)
      if(text==3||text==4){
        this.sortName = lang[this.$route.query.type].zhen_18
      }else if(text==1||text==2){
        this.sortName = lang[this.$route.query.type].zhen_20
      }else{
        this.sortName = lang[this.$route.query.type].zhen_19
      }
      
      this.sort = text
      this.clickSory = true
      this.getData()
      this.showSort = false
    }
  }
}
</script>



